import { render, staticRenderFns } from "./presentation_tree.vue?vue&type=template&id=14644e7d&scoped=true&"
import script from "./presentation_tree.vue?vue&type=script&lang=js&"
export * from "./presentation_tree.vue?vue&type=script&lang=js&"
import style0 from "./presentation_tree.vue?vue&type=style&index=0&id=14644e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14644e7d",
  null
  
)

export default component.exports